import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CookieConsentManager } from "../apply";
import { apply } from "../apply";
import { BANNER_PRE_DECISION_SHOW_EVENT } from "../events";
import { ready } from "../utils";

function preDecisionGateway(_x, _x2) {
  return _preDecisionGateway.apply(this, arguments);
}

function _preDecisionGateway() {
  _preDecisionGateway = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options, handler) {
    var show, useOptions, gateways, args, onIsDoNotTrack, onShowCookieBanner, _iterator, _step, gateway, result, _ret;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            show = true;
            useOptions = options instanceof CookieConsentManager ? options.getOptions() : options;
            gateways = handler.gateways, args = handler.args, onIsDoNotTrack = handler.onIsDoNotTrack, onShowCookieBanner = handler.onShowCookieBanner;
            _iterator = _createForOfIteratorHelper(gateways);
            _context.prev = 4;

            _iterator.s();

          case 6:
            if ((_step = _iterator.n()).done) {
              _context.next = 17;
              break;
            }

            gateway = _step.value;
            _context.next = 10;
            return gateway.apply(void 0, [useOptions].concat(_toConsumableArray(args)));

          case 10:
            result = _context.sent;

            if (!(result !== false)) {
              _context.next = 15;
              break;
            }

            _ret = function () {
              show = false;

              var applyCookiesWithOptions = function applyCookiesWithOptions(type) {
                return apply(_objectSpread({
                  type: type
                }, useOptions));
              };

              if (result === "all") {
                applyCookiesWithOptions("all");
              } else if (result === "essentials") {
                applyCookiesWithOptions("essentials");
              } else if (result === "dnt") {
                onIsDoNotTrack(function () {
                  return applyCookiesWithOptions("essentials");
                });
              } else if (result === "consent") {
                // Apply cookies for the current user decision
                applyCookiesWithOptions("consent");
              }

              return "break";
            }();

            if (!(_ret === "break")) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("break", 17);

          case 15:
            _context.next = 6;
            break;

          case 17:
            _context.next = 22;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](4);

            _iterator.e(_context.t0);

          case 22:
            _context.prev = 22;

            _iterator.f();

            return _context.finish(22);

          case 25:
            if (!show) {
              _context.next = 30;
              break;
            }

            onShowCookieBanner(); // Wait all events are initialized

            _context.next = 29;
            return ready();

          case 29:
            document.dispatchEvent(new CustomEvent(BANNER_PRE_DECISION_SHOW_EVENT, {
              detail: {}
            }));

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 19, 22, 25]]);
  }));
  return _preDecisionGateway.apply(this, arguments);
}

export { preDecisionGateway };